import {Stack, useTheme} from "@mui/material";
import {ThemeProvider} from "@mui/system";
import {useIsMobileContext} from "@nitra/nkmb-card-components";
import React, {useState} from "react";
import Banner from "../../components/Banner";
import {VoteOption} from "../../models";
import {VotePopup} from "./VotePopup";
import {VotingOptionsListContainer} from "./VotingOptionsListContainer";

export interface VotingContainerProps {
	voteOptions: VoteOption[];
	desktopBannerUrl: string;
	mobileBannerUrl: string;
	votingKey: string;
	children?: React.ReactNode;
}

export function VotingPage({
	                           voteOptions,
	                           desktopBannerUrl,
	                           mobileBannerUrl,
	                           votingKey,
	                           children
                           }: VotingContainerProps) {
	const [selectedOption, setSelectedOption] = useState<VoteOption | null>(null);
	const [isVotePopupOpen, setIsVotePopupOpen] = useState(false);

	const isMobile = useIsMobileContext();
	const theme = useTheme();

	const handleOptionSelect = (option: VoteOption) => {
		setSelectedOption(option);
		setIsVotePopupOpen(true);
	};

	return (
		<Stack>
			<Banner
				imageUrl={isMobile ? mobileBannerUrl : desktopBannerUrl}
				desktopHeight={isMobile ? 1080 : 480}
				sx={{mt: isMobile ? 0 : 0}}
			/>
			<Stack sx={{px: 2}}>
				<ThemeProvider theme={theme}>
					{children}


				</ThemeProvider>
				<Stack spacing={2}>
					<VotingOptionsListContainer
						voteOptions={voteOptions}
						onOptionSelect={handleOptionSelect}
						title={"GLASUJ IN OSVOJI ENO IZMED NAGRAD."}
						titleAlignCenter={true}
					/>
					{selectedOption && (
						<VotePopup
							open={isVotePopupOpen}
							onClose={() => setIsVotePopupOpen(false)}
							selectedOption={selectedOption}
							votingKey={votingKey}
						/>
					)}
				</Stack>
			</Stack>
		</Stack>
	)
}
